import React from "react";
import { useTranslation } from "react-i18next";
import "./Infographic.css";
import videoBG from "./bgVideo3.mp4";

function Metric({ number, title }) {
  return (
    <div className="metric">
      <div className="metric-number">{number}</div>
      <div className="metric-title">{title}</div>
    </div>
  );
}

function Infographic() {
  const { t } = useTranslation();
  
  const metrics = [
    { number: t("infographic.metrics.m1.number"), title: t("infographic.metrics.m1.title") },
    { number: t("infographic.metrics.m2.number"), title: t("infographic.metrics.m2.title") },
    { number: t("infographic.metrics.m4.number"), title: t("infographic.metrics.m4.title") },
    { number: t("infographic.metrics.m5.number"), title: t("infographic.metrics.m5.title") },
    { number: t("infographic.metrics.m6.number"), title: t("infographic.metrics.m6.title") },
  ];

  return (
    <section className="infographic-root" style={{ fontFamily: "Prompt, sans-serif", position: "relative", overflow: "hidden" }}>
      
      {/* --- Video Background --- */}
      <video
        className="infographic-video"
        src={videoBG}
        autoPlay
        muted
        loop
        playsInline
      />

      {/* --- Overlay --- */}
      <div className="infographic-overlay" />

      {/* --- Content --- */}
      <div className="infographic-content container">
        <p className="infographic-subtext">
          {t("infographic.subtext")}
        </p>

        <div className="infographic-grid">
          <div className="grid-inner">
            {metrics.map((m, i) => (
              <div key={i} className={`grid-cell cell-${i}`}>
                <Metric number={m.number} title={m.title} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Infographic;
